<template>
  <v-dialog v-model="dialog" width="80%" max-width="500px" attach="#app">
    <template v-slot:activator="{ on, attrs }">
      <div>
        <v-btn v-bind="attrs" dark v-on="on" icon text>
          <v-icon size="42">mdi-information</v-icon>
        </v-btn>
      </div>
    </template>

    <v-card class="infobox__wrapper">
      <v-card-title class="headline">
        {{ $t('infoBox.title') }}
      </v-card-title>

      <v-card-text>
        <div class="infobox-info">
          <p>
            {{ $t('infoBox.generalInfo') }}
          </p>
          <p>
            {{ $t('infoBox.information') }}
          </p>
        </div>
        <v-divider></v-divider>
        <div class="legend-component">
          <h3>
            {{ $t('infoBox.eventLabel') }}
          </h3>
          <Legend />
        </div>
        <div class="language-picker">
          <h4>{{ $t('infoBox.languagePicker') }}:</h4>
          <a href="" @click.prevent="changeLanguage('hu')" :class="currentLangCode === 'hu' ? 'inactive' : ''">{{
            $t('infoBox.huLanguage')
          }}</a>
          /
          <a href="" @click.prevent="changeLanguage('en')" :class="currentLangCode === 'en' ? 'inactive' : ''">{{
            $t('infoBox.enLanguage')
          }}</a>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Legend from 'Components/Legend';

export default {
  name: 'InfoBox',
  components: { Legend },
  data: () => {
    return {
      dialog: false
    };
  },
  methods: {
    changeLanguage(langCode) {
      if (this.currentLangCode === langCode) return;
      this.$root.$i18n.locale = langCode;
    }
  },
  computed: {
    currentLangCode() {
      return this.$root.$i18n.locale;
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'Plugins/style/breakpoints';

.infobox__wrapper {
  .headline {
    font-size: 1.3em;
    margin: 0 0 18px 0;
  }
  .infobox-info {
    font-size: 1em;
    text-align: justify;
    p {
      margin: 0 0 8px 0;
    }
  }
  .legend-component {
    padding: 12px 0;
    h3 {
      font-weight: 500;
      margin-bottom: 12px;
    }
  }
  .language-picker {
    h4 {
      margin-right: 1em;
    }
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 24px 0;

    a.inactive {
      text-decoration: none;
      cursor: default;
      color: rgba(0, 0, 0, 0.6);
    }
  }
  .attribution {
    margin: 20px 0 8px 0;
    text-align: center;
    font-size: 0.8em;
  }

  @media (min-width: $phone) and (max-width: $tablet) {
  }

  @media (min-width: $tablet) and (max-width: $desktop) {
    .headline {
      font-size: 1.6em;
      margin: 0 0 22px 0;
    }
    .infobox-info {
      font-size: 1.2em;
      p {
        margin: 0 0 12px 0;
      }
    }
    .attribution {
      font-size: 1em;
    }
  }

  @media (min-width: $desktop) {
    .headline {
      font-size: 1.6em;
      margin: 0 0 24px 0;
    }
    .infobox-info {
      font-size: 1.3em;
      text-align: justify;
      p {
        margin: 0 0 8px 0;
      }
    }
    .attribution {
      font-size: 1.1em;
    }
  }
}
</style>
